<template>
  <section id="services" class="section bg-gray-50 dark:bg-dark-bg relative overflow-hidden">
    <!-- Background Decoration -->
    <div class="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-accent/5 to-transparent pointer-events-none"></div>

    <div class="container-custom relative z-10">
      <!-- Section Header -->
      <div class="text-center mb-16 animate-reveal">
        <h2 class="text-4xl md:text-5xl font-display font-bold text-gray-900 dark:text-white mb-4">
          What We Do Best
        </h2>
        <p class="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
          We deliver transformative digital solutions through strategic thinking, technical excellence, and collaborative partnerships
        </p>
      </div>

      <!-- Services Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 stagger-children">
        <ServiceCard
          v-for="service in services"
          :key="service.id"
          :title="service.title"
          :description="service.description"
          :icon="service.icon"
          :features="service.features"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import ServiceCard from '@/components/ui/ServiceCard.vue';
import { services } from '@/data/services.js';
</script>
